module.exports = __webpack_public_path__ + "media/proksee-viewer/images/sidebar-open-090a1a7db8455d7efea03a33772613b5.png";